<template>
  <div>
    Attachments
  </div>
</template>

<script>
export default {

}
</script>
